// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AddressSharedStyles from "@ces/App/SharedStyles/LocationPage/LocationAddressStyles";
import { pickUpAddressStyles } from "@ces/Overrides/Widgets/CheckoutShipping/PickUpAddress";
import Change from "@ces/XDL/Icons/Change";
import { color, createLinkIconStyles } from "@ces/XDL/Utilities";
import { css } from "styled-components";

pickUpAddressStyles.headingText = {
    variant: "h6",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};

pickUpAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: center;
        gap: 8px;
    `,
};

pickUpAddressStyles.findLocationLink = {
    ...createLinkIconStyles({
        icon: Change,
        iconStyles: {
            size: 12,
            css: css`
                &,
                & > svg {
                    height: 13px;
                }
            `,
        },
        typographyStyles: {
            size: 12,
            lineHeight: "15px",
        },
    }),
};

pickUpAddressStyles.container = {
    gap: 12,
};

pickUpAddressStyles.questionIconStyles = {
    size: 12,
    css: css`
        height: 13px;
        opacity: 0.66;
        color: ${color("text.link")};
        &:hover {
            opacity: 1;
        }
    `,
};

pickUpAddressStyles.tooltipContainer = {
    cssOverrides: {
        tooltipWrapper: css`
            display: flex;
            & > span {
                margin: 0;
            }
        `,
    },
};

pickUpAddressStyles.selectedLocationName = {
    size: 14,
    lineHeight: "22px",
    color: "common.ui6",
};

pickUpAddressStyles.selectedLocationAddressDisplay = {
    ...AddressSharedStyles.address,
};
